// @file Store for current user
import { getVuexStore } from '@@/bits/pinia'
import { UserRole } from '@@/bits/user_model'
import type { UserWithHashId } from '@@/types'
import type { RootState } from '@@/vuexstore/surface/types'
import { defineStore } from 'pinia'
import { computed } from 'vue'

const useSurfaceCurrentUserStore = defineStore('surfaceCurrentUser', () => {
  const surfaceVuexStore = getVuexStore<RootState>()

  // Getters
  const currentUser = computed<UserWithHashId>(() => surfaceVuexStore?.getters.user as UserWithHashId)

  /**
   * Returns true if user has super admin privileges.
   * Replicates backend logic from services/rails/app/models/user.rb#with_native_superpowers?
   */
  const isSuperAdmin = computed(() => {
    const isNativeAdmin =
      currentUser.value.tenant_id === 1 && [UserRole.OWNER, UserRole.ADMIN].includes(currentUser.value.role)

    const emailDomain = currentUser.value.email?.split('@')[1]
    const hasWallwisherEmail = emailDomain === 'wallwisher.com'

    // Must be native admin with wallwisher.com email (Google SSO is enforced server-side)
    return isNativeAdmin && hasWallwisherEmail
  })

  return {
    // Getters
    currentUser,
    isSuperAdmin,
  }
})
export { useSurfaceCurrentUserStore }
